import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import {
  Response,
  LoginRequest,
  LoginResponse,
  PasswordRequest,
  RefreshTokenRequest,
  QueryRequest,
  LogoutResponse,
  PasswordResponse,
  LoginByCertificateRequest,
  CheckDomainRequest,
  LoginByTokenRequest
} from '@models/index.model';
import { UtilsService } from '@utils/utils.service';

@Injectable()
export class UserPinAuthService {
  private UrlAPI = environment.apiAuthUrl;

  constructor(private http: HttpClient, private _utils: UtilsService) {}

  public logIn(loginRequest: LoginRequest): Observable<Response<LoginResponse>> {
    const query = this.UrlAPI + QueryRequest.authLogin;
    const httpHeaders = new HttpHeaders({ 'user-pin': 'logIn' });
    const options = { headers: httpHeaders };
    return this.http.post<Response<LoginResponse>>(query, this._utils.stringifyData(loginRequest), options);
  }

  // public changePassword(passwordRequest: PasswordRequest): Observable<Response<PasswordResponse>> {
  //   const query = this.UrlAPI + QueryRequest.authPassword;
  //   const httpHeaders = new HttpHeaders({ 'user-pin': 'login' });
  //   const options = { headers: httpHeaders };
  //   return this.http.put<Response<PasswordResponse>>(query, this._utils.stringifyData(passwordRequest), options);
  // }

  public loginByCertificate(loginByCertificateRequest: LoginByCertificateRequest): Observable<Response<LoginResponse>> {
    const query = this.UrlAPI + QueryRequest.authLoginByCertificate;
    const httpHeaders = new HttpHeaders({ 'user-pin': 'loginByCertificate' });
    const options = { headers: httpHeaders };
    return this.http.post<Response<LoginResponse>>(query, this._utils.stringifyData(loginByCertificateRequest), options);
  }

  public loginByToken(loginByTokenRequest: LoginByTokenRequest): Observable<Response<LoginResponse>> {
    const query = this.UrlAPI + QueryRequest.authLoginByToken;
    const httpHeaders = new HttpHeaders({ 'user-pin': 'loginByToken' });
    const options = { headers: httpHeaders };
    return this.http.post<Response<LoginResponse>>(query, this._utils.stringifyData(loginByTokenRequest), options);
  }

  public logout(): Observable<Response<LogoutResponse>> {
    const query = this.UrlAPI + QueryRequest.authLogout;
    const httpHeaders = new HttpHeaders({ 'user-pin': 'logout' });
    const options = { headers: httpHeaders };
    return this.http.delete<Response<LogoutResponse>>(query, options);
  }

  public checkDomain(checkDomainRequest: CheckDomainRequest): Observable<Response<string>> {
    const query = this.UrlAPI + QueryRequest.authCheckDomain;
    const httpHeaders = new HttpHeaders({ 'user-pin': 'checkDomain' });
    const options = { headers: httpHeaders };
    return this.http.post<Response<string>>(query, this._utils.stringifyData(checkDomainRequest), options);
  }

  public personalSSODomain(): Observable<Response<string>> {
    const query = this.UrlAPI + QueryRequest.personalSSODomain;
    const httpHeaders = new HttpHeaders({ 'user-pin': 'personalSSODomain' });
    const options = { headers: httpHeaders };
    return this.http.get<Response<string>>(query, options);
  }
}
